import { throttle } from 'lodash';

export function windowAction() {
  const pageTop = document.querySelector('.js-pageTop');

  window.addEventListener(
    'scroll',
    _.throttle(
      (e) => {
        scrollView();
        return false;
      },
      10,
      { trailing: true, leading: true }
    )
  );

  // ページ読み込み時にスクロールトップボタンがkvより下にあれば表示
  window.addEventListener('load', () => {
    const scroll = window.pageYOffset;
    if (scroll > 100) {
      pageTop.classList.add('is-view');
    } else {
      pageTop.classList.remove('is-view');
    }
  });

  // 間引きしたい処理
  function scrollView() {
    const scroll = window.pageYOffset;

    // スクロール量がkvの高さを超えたらページトップボタンを表示
    if (scroll > 100) {
      pageTop.classList.add('is-view');
    } else {
      pageTop.classList.remove('is-view');
    }
  }
}
